import { ID, Account, Databases, Client, Query, Storage, Role, Permission } from 'appwrite'

export const DB_NAME = process.env.VUE_APP_DB_ID
export const BUCKET_ID = process.env.VUE_APP_BUCKET

const client = (new Client())
    .setEndpoint(process.env.VUE_APP_APPWRITE_ENDPOINT)
    .setProject(process.env.VUE_APP_APPWRITE_PROJECT_ID)

export const databases = new Databases(client)
const storage = new Storage(client)
const account = new Account(client)

export default {
    DB_NAME,
    client,
    databases,
    account,
    Query,
    ID,

    getPermissions: () => {
        return [
            Permission.read(Role.users()),
            Permission.update(Role.users()),
            Permission.delete(Role.users()),
        ]
    },

    getFileUrl: (id) => {
        return storage.getFileView(BUCKET_ID, id)
    },

    getFileThumb: async (id) => {
        const { href } = await storage.getFilePreview(
            BUCKET_ID,
            id,
            300,
            366,
            'top',
            100,
            0,
            'ffffff',
            0,
            1,
            0,
            'ffffff',
            'jpg',
        )

        return href
    },

    uploadFile: async (file) => {
        const { $id: userId } = await account.get()
        const permittedUser = Role.user(userId)

        const permissions = [
            Permission.read(permittedUser),
            Permission.delete(permittedUser),
        ]

        const { $id } = await storage.createFile(BUCKET_ID, ID.unique(), file, permissions)

        return $id
    },

    deleteFile: async (id) => {
        await storage.deleteFile(BUCKET_ID, id)
    },
}
